import { render, staticRenderFns } from "./A4Type1.vue?vue&type=template&id=1a19f8fc&"
import script from "./A4Type1.vue?vue&type=script&lang=js&"
export * from "./A4Type1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports